import { DocumentControllerApi, JobDocumentDto, LoanControllerApi, LoanDocumentDto } from 'client';
import { DATA_LAYER_RESPONSE_KEY } from 'constants/DataLayers';
import {
	RESPONSE_PATH,
	RESPONSE_VIEW_DOCUMENT_UPDATE_INCOMPLETE,
	RESPONSE_VIEW_ERROR,
} from 'constants/ResponseType';
import { LoandingContext } from 'context/LoandingContext';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getTokenFromStorage } from 'utils/GetTokenFromStorage';

export const useDocument = (
	setShowLoadingModal: Function,
	uploadedDocument?: LoanDocumentDto[]
) => {
	const history = useHistory();
	const [documents, setDocuments] = useState<LoanDocumentDto[]>(
		uploadedDocument ? uploadedDocument : []
	);
	const [isInstantUser, setIsInstantUser] = useState(false);
	const [jobType, setJobType] = useState('');
	const [documentTypes, setDocumentTypes] = useState<JobDocumentDto[]>([]);

	const loanDocumentService = new DocumentControllerApi();
	const loanServices = new LoanControllerApi();
	const { setLoading } = useContext(LoandingContext);

	const onDelete = (id: number) => {
		setShowLoadingModal(true);
		loanDocumentService
			.deleteLoanDocumentUsingDELETE(getTokenFromStorage(), id)
			.then((_) => {
				setDocuments(documents.filter((doc) => doc.id !== id));
				setShowLoadingModal(false);
			})
			.catch((_) => {
				history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
			});
	};

	const addDocument = (
		crmId: string,
		type: string,
		success: Function,
		error: Function,
		file?: File
	) => {
		if (file) {
			setShowLoadingModal(true);
			loanDocumentService
				.uploadLoanDocumentUsingPOST(getTokenFromStorage(), crmId, type, file, 'LOAN')
				.then((response) => {
					success(response);
					setShowLoadingModal(false);
				})
				.catch((err) => {
					error(err);
				});
		}
	};

	const getDocuments = async (crmId: string) => {
		setShowLoadingModal(true);
		await loanDocumentService
			.fetchLoanDocumentUsingGET(getTokenFromStorage(), crmId)
			.then((response) => {
				const { loanDocument, isInstant, jobType, documentType } = response.data;
				setDocuments(loanDocument ? loanDocument : []);
				setIsInstantUser(isInstant ? isInstant : false);
				setJobType(jobType ? jobType : '');
				setDocumentTypes(documentType ? documentType : []);
				setShowLoadingModal(false);
				setLoading(false);
			})
			.catch((_: any) => {
				history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
				setLoading(false);
				setShowLoadingModal(false);
			});
	};

	const notifyIncompleteDocuments = (crmId: string) => {
		setShowLoadingModal(true);
		loanServices
			.notificationLoanDocumentUsingGET('WITHOUT_DOCUMENT', getTokenFromStorage(), crmId)
			.then(() => {
				history.push(
					`${RESPONSE_PATH}/${RESPONSE_VIEW_DOCUMENT_UPDATE_INCOMPLETE}/${DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_SIN_DOCUMENTOS}`
				);
			})
			.catch(() => {
				history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
			});
	};

	return {
		documents,
		isInstantUser,
		setDocuments,
		onDelete,
		addDocument,
		getDocuments,
		notifyIncompleteDocuments,
		jobType,
		documentTypes,
	} as const;
};
